import { createSelector } from 'reselect'
import dayjs from 'dayjs'
import { PeriodGroup } from '../../../types/periodGroup/PeriodGroup'
import { Store } from '../../types'
import { ReportDataType } from '../reports/types'
import { parseDate } from '../../../config/dayjsConfig'
import { ApiPeriodGroup } from '../actions'
import { PeriodGroupSelection } from './types'

export const contexFiltersSelector = (store: Store) => {
  return store.context.filters
}

export const filtersSelector = createSelector(contexFiltersSelector, filters => {
  const { dataTypes, ...rest } = filters
  const order = [
    ReportDataType.actuals,
    ReportDataType.comparativePeriod,
    ReportDataType.budget,
    ReportDataType.forecast
  ]
  const orderedDataTypes = order.filter(type => dataTypes.includes(type))
  return { ...rest, dataTypes: orderedDataTypes }
})

const emptyArray: PeriodGroup[] = []

export const periodGroupSelector = createSelector(
  (store: Store) => store.context?.filters?.periodGroups,
  periodGroups => periodGroups || emptyArray
)

// export const sortedPeriodGroups = createSelector(periodGroupSelector, periodGroups => {
//   const sortedPeriodGroupsArray: PeriodGroup[] = periodGroups
//     .slice()
//     .sort((n1: PeriodGroup, n2: PeriodGroup) => +new Date(n1.endDate) - +new Date(n2.endDate))
//   return sortedPeriodGroupsArray
// })

export const forecastCursorSelector = createSelector(filtersSelector, ({ budgetingScenario }) => {
  return budgetingScenario?.forecastCursor ? parseDate(budgetingScenario.forecastCursor) : undefined
})

/**
 * Selector that returns period groups in API-compatible format (without periods array)
 */
export const apiPeriodGroupsSelector = createSelector(
  periodGroupSelector,
  (periodGroups): ApiPeriodGroup[] | undefined => {
    if (!periodGroups || periodGroups.length === 0) return undefined
    return periodGroups.map(({ id, startDate, endDate, budgetable }) => ({
      id,
      startDate,
      endDate,
      budgetable
    }))
  }
)

const formatPeriodGroupSelection = (selection: PeriodGroupSelection): string => {
  switch (selection.type) {
    case 'fiscalYear': {
      const months = dayjs.monthsShort()
      return `${months[selection.startMonth]} – ${months[selection.endMonth]}`
    }
    case 'custom':
      return selection.ranges
        .map(r => `${dayjs(r.startDate).format('MM/YYYY')} – ${dayjs(r.endDate).format('MM/YYYY')}`)
        .join(', ')
    case 'quarters':
      return selection.entries.map(e => `${e.quarters.map(q => `Q${q}`).join(', ')} / ${e.year}`).join(', ')
    default:
      return ''
  }
}

export const periodGroupSelectionLabelSelector = createSelector(
  contexFiltersSelector,
  periodGroupSelector,
  (filters, periodGroups): string | undefined => {
    if (!filters.periodGroupSelection || !periodGroups.length) return undefined
    return formatPeriodGroupSelection(filters.periodGroupSelection)
  }
)
